import { merge } from 'lodash'
import { country, TYPES as COUNTRY_TYPES } from './country/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      l10n: {
        namespaced: true,
        modules: {
          country
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    COUNTRY_TYPES
  )

export { store, TYPES }
